mutation DisableOrganizationUser($id: ID!) {
  disableOrganizationUser(id: $id) {
    id
    disabled
  }
}
